/* unplugin-vue-components disabled */import script from "./OpenConfiguratorModel.vue?vue&type=script&lang=ts&setup=true"
export * from "./OpenConfiguratorModel.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__